export const MapboxConfig = {
    web: "pk.eyJ1IjoiaW1waGFsY2FicyIsImEiOiJjbW1sdnQzam8yMDI0MnNzb3hjdHJpeGJjIn0.X6W-w7GYJs0603eDCUybpQ"
};
